import {
  Component,
  OnInit,
  Inject
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent implements OnInit {
  strTitle: string;
  strDescription: string;

  constructor(public dialogRef: MatDialogRef<ConfirmModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.strTitle = data['title'];
    this.strDescription = data['description'];
  }

  ngOnInit() {
  }

  onAgree() {
    this.dialogRef.close(true);
  }

  onClose() {
    this.dialogRef.close(false);
  }

}
